import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { routes } from './routes'

export const RouterPublic = () => {
    const location = useLocation()
    const history = useNavigate()

    useEffect(() => {
        if (!location.hash) {
            history("/", {
                state: {
                    from: location
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            <Routes>
                {
                    routes.public.map((route) => (
                        <Route key={route.path} path={route.path} element={<route.component />} />
                    ))
                }

                <Route path='/*' element={<Navigate to={routes.public[0].to} replace />} />
            </Routes>

        </>
    )
}
